import { useState } from "react";
import { Table } from "../../../../../components/Table";
import { Member } from "../../../../../services/api/types/Roles";
import { useAppSelector } from "../../../../../store/hooks";
import { getColumns } from "../columnData";

interface MembersTabType {
  handleAddTeamMember?: () => void;
  members: Array<Member>;
  selectedRows: any;
  handleDeleteSelected?: () => void;
  role: any;
}

export const MembersTab: React.FC<MembersTabType> = ({
  handleAddTeamMember,
  members,
  selectedRows,
  handleDeleteSelected,
  role,
}) => {
  const token = useAppSelector(state => state.auth.token);
  const [isLoading] = useState<boolean>(false);
  return (
    <div>
      <Table
        editable
        tableType="Members"
        isLoading={isLoading}
        defaultRows={!members.length ? 0 : 20}
        columns={getColumns(role, token)}
        rowsPerPage={[10, 20, 35, 50]}
        data={members}
        selectedRows={selectedRows}
        handleDeleteSelected={handleDeleteSelected}
        handleAddTeamMember={handleAddTeamMember}
      />
    </div>
  );
};
